import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export interface FilterOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  id?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: FilterOption[];
  allLabel?: string;
  placeholder?: string;
  className?: string;
}

/**
 * Универсальный компонент фильтра-селекта для использования в TableToolbar
 */
export function FilterSelect({
  id,
  label,
  value,
  onChange,
  options,
  allLabel = 'Все',
  placeholder,
  className,
}: FilterSelectProps) {
  const selectId = id || `filter-${label.toLowerCase().replaceAll(/\s+/g, '-')}`;

  return (
    <div className={className}>
      <Label htmlFor={selectId} className="text-sm font-medium">
        {label}
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={selectId} className="mt-1.5">
          <SelectValue placeholder={placeholder || label} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{allLabel}</SelectItem>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
